import assets from '../../assets'
import { useT } from '../../i18n'
import Lottie from '../lottie/Lottie'
import style from '../../styles/components/shopping-cart.module.scss'

const CartEmptyState = () => {
    const t = useT()

    return (
        <div className={style.cartEmpty}>
            <div className={style.animation}>
                <Lottie data={assets.json.empty} loop />
            </div>
            <div className={style.label}>{t('Your cart is empty')}</div>
        </div>
    )
}

export default CartEmptyState
